// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\DTO.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumGender } from '../../../../../com/MetaPattern/APP/MDA/User/EnumGender';
import { EnumOrganizationType } from '../../../../../com/MetaPattern/APP/MDA/User/EnumOrganizationType';
import { EnumTenancyType } from '../../../../../com/MetaPattern/APP/MDA/User/EnumTenancyType';
/**
 * 注册信息DTO DTO类
 * 注册信息DTO
 */
export class RegistInfoDTO {
  /** 登录名称 : 登录名称，全局唯一 */
  private _loginName: string;

  /** 设置：登录名称 */
  public get loginName() {
    return this._loginName;
  }

  /** 获取：登录名称 */
  public set loginName(value: string) {
    this._loginName = value;
  }

  /** 手机号 : 手机号 */
  private _mobile: string;

  /** 设置：手机号 */
  public get mobile() {
    return this._mobile;
  }

  /** 获取：手机号 */
  public set mobile(value: string) {
    this._mobile = value;
  }

  /** 邮件地址 : 邮件地址 */
  private _email: string;

  /** 设置：邮件地址 */
  public get email() {
    return this._email;
  }

  /** 获取：邮件地址 */
  public set email(value: string) {
    this._email = value;
  }

  /** 短信验证码 : 短信验证码 */
  private _sMSCode: string;

  /** 设置：短信验证码 */
  public get sMSCode() {
    return this._sMSCode;
  }

  /** 获取：短信验证码 */
  public set sMSCode(value: string) {
    this._sMSCode = value;
  }

  /** 昵称 : 昵称 */
  private _nickName: string;

  /** 设置：昵称 */
  public get nickName() {
    return this._nickName;
  }

  /** 获取：昵称 */
  public set nickName(value: string) {
    this._nickName = value;
  }

  /** 登录密码 : 登录密码 */
  private _password: string;

  /** 设置：登录密码 */
  public get password() {
    return this._password;
  }

  /** 获取：登录密码 */
  public set password(value: string) {
    this._password = value;
  }

  /** 姓名 : 个人的真实姓名 */
  private _personName: string;

  /** 设置：姓名 */
  public get personName() {
    return this._personName;
  }

  /** 获取：姓名 */
  public set personName(value: string) {
    this._personName = value;
  }

  /** 出生日期 : 出生日期 */
  private _birthday: Date;

  /** 设置：出生日期 */
  public get birthday() {
    return this._birthday;
  }

  /** 获取：出生日期 */
  public set birthday(value: Date) {
    this._birthday = value;
  }

  /** 性别 : 性别 */
  private _gender: EnumGender;

  /** 设置：性别 */
  public get gender() {
    return this._gender;
  }

  /** 获取：性别 */
  public set gender(value: EnumGender) {
    this._gender = value;
  }

  /** 机构名称 : 机构的完整名称 */
  private _orgName: string;

  /** 设置：机构名称 */
  public get orgName() {
    return this._orgName;
  }

  /** 获取：机构名称 */
  public set orgName(value: string) {
    this._orgName = value;
  }

  /** 机构类型 : 机构类型 */
  private _orgType: EnumOrganizationType;

  /** 设置：机构类型 */
  public get orgType() {
    return this._orgType;
  }

  /** 获取：机构类型 */
  public set orgType(value: EnumOrganizationType) {
    this._orgType = value;
  }

  /** 租户类型 : 租户类型 */
  private _tenancyType: EnumTenancyType;

  /** 设置：租户类型 */
  public get tenancyType() {
    return this._tenancyType;
  }

  /** 获取：租户类型 */
  public set tenancyType(value: EnumTenancyType) {
    this._tenancyType = value;
  }

  constructor() {
    this._loginName = '';
    this._mobile = '';
    this._email = '';
    this._sMSCode = '';
    this._nickName = '';
    this._password = '';
    this._personName = '';
    this._birthday = new Date();
    this._gender = EnumGender.None;
    this._orgName = '';
    this._orgType = EnumOrganizationType.Company;
    this._tenancyType = EnumTenancyType.Person;
  }

  public toJson(): any {
    const json = {};
    this.Serialize(json);
    return json;
  }

  protected Deserialize(json: any): void {
    this.loginName = json.LoginName;
    this.mobile = json.Mobile;
    this.email = json.Email;
    this.sMSCode = json.SMSCode;
    this.nickName = json.NickName;
    this.password = json.Password;
    this.personName = json.PersonName;
    this.birthday = new Date(json.Birthday);
    this.gender = json.Gender as EnumGender;
    this.orgName = json.OrgName;
    this.orgType = json.OrgType as EnumOrganizationType;
    this.tenancyType = json.TenancyType as EnumTenancyType;
  }

  protected Serialize(json: any): void {
    json.LoginName = this.loginName;
    json.Mobile = this.mobile;
    json.Email = this.email;
    json.SMSCode = this.sMSCode;
    json.NickName = this.nickName;
    json.Password = this.password;
    json.PersonName = this.personName;
    json.Birthday = this.birthday;
    json.Gender = this.gender;
    json.OrgName = this.orgName;
    json.OrgType = this.orgType;
    json.TenancyType = this.tenancyType;
  }

  static Create(json: any): RegistInfoDTO {
    const registInfoDTO = new RegistInfoDTO();
    registInfoDTO.Deserialize(json);
    return registInfoDTO;
  }
}
